import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const SoloCompiPage = ({ user, competition, setCompetition }) => {
  const navigate = useNavigate();
  const [participants, setParticipants] = useState([]);

  const getCompiParticipants = async () => {
    if (competition.isSlottingDone) {
      await Axios.get(
        `https://ashish.moodi.org/multicity/get_solo_slot_reg?id=${competition.mcId}`
      )
        .then((res) => setParticipants(res.data))
        .catch((err) => console.error(err));
    } else {
      await Axios.get(
        `https://ashish.moodi.org/multicity/get_solo_compi_reg?id=${competition.mcId}`
      )
        .then((res) => setParticipants(res.data))
        .catch((err) => console.error(err));
    }
  };

  const download_csv_file = () => {
    var csv = ",Name,MI Number,Phone,Email,College,City\n";
    participants.forEach((participant) => {
      csv +=
        participant.userName +
        "," +
        participant.MI_NO +
        "," +
        participant.phone +
        "," +
        participant.email +
        "," +
        `'${participant.collegeName}'` +
        "," +
        `'${participant.cityName}'` +
        "\n";
    });
    var hiddenElement = document.createElement("a");
    console.log(csv);
    hiddenElement.href = "data:text/csv;charset=utf-8" + encodeURI(csv);
    hiddenElement.target = "_blank";
    hiddenElement.download = `${competition.mcName}.csv`;
    hiddenElement.click();
  };

  const download_full_user_csv = () => {
    var csv =
      ",Name,MI Number,Gender,Email,Phone,Date Of Birth,Year of Study,Stream,Referral Code,CCP Points,College, City\n";
    Axios.get("https://ashish.moodi.org/users/download_user_data").then(
      (res) => {
        res.data.forEach((element) => {
          csv +=
            element.userName +
            "," +
            element.MI_NO +
            "," +
            element.gender +
            "," +
            element.email +
            "," +
            element.phone +
            "," +
            element.dob +
            "," +
            element.yearOfStudy +
            "," +
            element.stream +
            "," +
            element.referralCode +
            "," +
            element.ccpPoints +
            "," +
            element.collegeName +
            "," +
            element.cityName +
            "\n";
        });
        var hiddenElement = document.createElement("a");
        hiddenElement.href = "data:text/csv;charset=utf-8" + encodeURI(csv);
        hiddenElement.target = "_blank";
        hiddenElement.download = "user_full_data.csv";
        hiddenElement.click();
      }
    );
  };

  useEffect(() => {
    getCompiParticipants();
    // console.log(competition);
  }, [competition]);

  return (
    <div className="container-fluid overflow-auto">
      <div className="row my-3">
        <h2 className="text-center col-sm-3">{competition.mcName}</h2>
        <p className="text-center col-sm-3">
          Total registrations: {participants.length}
        </p>
        {user ? (
          user.isAdminCooride ? (
            <button
              className="btn btn-primary col-sm-2"
              onClick={download_csv_file}
            >
              Download CSV
            </button>
          ) : user.isSuperUser ? (
            <button
              className="btn btn-primary col-sm-2"
              onClick={download_csv_file}
            >
              Download CSV
            </button>
          ) : (
            <></>
          )
        ) : (
          <></>
        )}

        <button
          className="btn btn-primary col-sm-2"
          onClick={() =>
            navigate(`/admin/multicity/slotting/${competition.mcId}`)
          }
        >
          Do Slotting
        </button>

        {user ? (
          user.isAdminCooride ? (
            <button
              className="btn btn-primary col-sm-2"
              onClick={() =>
                navigate(`/admin/mul/compi_score/${competition.mcId}`)
              }
            >
              View Score Sheet
            </button>
          ) : user.isCoordie ? (
            <button
              className="btn btn-primary col-sm-2"
              onClick={() =>
                navigate(`/admin/mul/compi_score/${competition.mcId}`)
              }
            >
              View Score Sheet
            </button>
          ) : user.isSuperUser ? (
            <button
              className="btn btn-primary col-sm-2"
              onClick={() =>
                navigate(`/admin/mul/compi_score/${competition.mcId}`)
              }
            >
              View Score Sheet
            </button>
          ) : (
            <></>
          )
        ) : (
          <></>
        )}
      </div>
      <table className="container-fluid overflow-auto">
        <thead>
          <tr className="row overflow-auto">
            {competition.isSlottingDone ? (
              <th className="col-sm-1">Slot Number</th>
            ) : (
              <></>
            )}
            <th className="col-sm-2">Name</th>
            <th className="col-sm-1">MI Number</th>
            <th className="col-sm-1">Phone</th>
            <th className="col-sm-3">Email</th>
            <th className="col-sm-2">College</th>
            <th className="col-sm-1">City</th>
            <hr />
            <hr />
          </tr>
        </thead>
        <tbody>
          {participants.map((participant) => {
            return (
              <>
                <tr className="row" key={participant.phone}>
                  {competition.isSlottingDone ? (
                    <td className="col-sm-1">{participant.slotNumber}</td>
                  ) : (
                    <></>
                  )}
                  <td className="col-sm-2">{participant.userName}</td>
                  <td className="col-sm-1">{participant.MI_NO}</td>
                  <td className="col-sm-1">{participant.phone}</td>
                  <td className="col-sm-3">{participant.email}</td>
                  <td className="col-sm-2">{participant.collegeName}</td>
                  <td className="col-sm-1">{participant.cityName}</td>
                </tr>
                <hr />
              </>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SoloCompiPage;
